<template>
  <div
    class="cbs-step-picker"
    @click.stop
  >
    <span
      class="cbs-step-picker__current"
      @click="toggle"
    >
      {{ displayVal || emptyLabel }}
    </span>

    <div
      v-if="open"
      class="cbs-step-picker__panel"
    >
      <b-form-input
        ref="searchInput"
        v-model="search"
        size="sm"
        :placeholder="placeholder"
        autocomplete="off"
        @input="onSearch"
        @keydown.esc="close"
        @keydown.enter.prevent="selectFirst"
      />
      <div
        v-if="filtered.length > 0"
        class="cbs-step-picker__list"
      >
        <div
          v-for="opt in filtered"
          :key="opt[valueKey]"
          class="cbs-step-picker__item"
          @click="select(opt)"
        >
          {{ opt[labelKey] }}
        </div>
      </div>
      <div
        v-else-if="search"
        class="cbs-step-picker__empty"
      >
        Не найдено
      </div>
    </div>

    <slot />
  </div>
</template>

<script>
import { BFormInput } from 'bootstrap-vue'

export default {
  name: 'CbsInlinePicker',
  components: { BFormInput },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    displayVal: {
      type: String,
      default: '',
    },
    valueKey: {
      type: String,
      default: 'value',
    },
    labelKey: {
      type: String,
      default: 'title',
    },
    placeholder: {
      type: String,
      default: 'Поиск...',
    },
    emptyLabel: {
      type: String,
      default: '(не выбран)',
    },
  },
  data() {
    return {
      open: false,
      search: '',
      filtered: [],
    }
  },
  mounted() {
    this._closeOnOutsideClick = e => {
      if (this.open && !this.$el.contains(e.target)) this.close()
    }
    document.addEventListener('click', this._closeOnOutsideClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this._closeOnOutsideClick)
  },
  methods: {
    toggle() {
      if (this.open) { this.close(); return }
      this.open = true
      this.search = ''
      this.filtered = [...this.options]
      this.$nextTick(() => {
        if (this.$refs.searchInput) this.$refs.searchInput.focus()
      })
    },
    close() {
      this.open = false
      this.search = ''
      this.filtered = []
    },
    onSearch() {
      if (!this.search.trim()) { this.filtered = [...this.options]; return }
      const parts = this.search.trim().toLowerCase().split(/\s+/)
      const re = new RegExp(parts.map(p => p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('.*'))
      this.filtered = this.options.filter(o => {
        const label = o[this.labelKey]
        return label && re.test(label.toLowerCase())
      })
    },
    selectFirst() {
      if (this.filtered.length > 0) this.select(this.filtered[0])
    },
    select(opt) {
      this.$emit('select', opt)
      this.close()
    },
  },
}
</script>

<style lang="scss" scoped>
.cbs-step-picker {
  flex: 1;
  max-width: 250px;
  font-size: 12px;
  position: relative;

  &__current {
    color: #7367f0;
    cursor: pointer;
    user-select: none;

    &:hover {
      text-decoration: underline;
    }
  }

  &__panel {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 10;
    width: 250px;
    background: #fff;
    border: 1px solid #ebe9f1;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 4px;
  }

  &__list {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 4px;
  }

  &__item {
    padding: 4px 8px;
    cursor: pointer;
    border-radius: 3px;
    color: #5e5873;

    &:hover {
      background: #f8f8f8;
    }
  }

  &__empty {
    padding: 6px 8px;
    color: #b9b9c3;
  }
}

.dark-layout {
  .cbs-step-picker {
    &__panel {
      background: #283046;
      border-color: #3b4253;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }

    &__item {
      color: #d0d2d6;

      &:hover {
        background: #3b4253;
      }
    }
  }
}
</style>
